// extracted by mini-css-extract-plugin
export default {"boxLoading":"style_boxLoading__x6sEd","loaderLine":"style_loaderLine__s5Brm","lineAnim":"style_lineAnim__oZFoS"};